var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateCcw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 3.25V9.25H7.75V10.75H1C0.585786 10.75 0.25 10.4142 0.25 10V3.25H1.75Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6401 2.35438C12.7334 2.05987 14.8656 2.45363 16.7156 3.47633C18.5656 4.49903 20.0332 6.09527 20.8971 8.02453C21.761 9.95379 21.9745 12.1116 21.5055 14.1727C21.0364 16.2339 19.9102 18.0868 18.2965 19.4522C16.6829 20.8177 14.6691 21.6217 12.5588 21.7432C10.4484 21.8646 8.35571 21.297 6.59603 20.1257C4.83635 18.9544 3.505 17.2429 2.80257 15.2492L2.55335 14.5418L3.96811 14.0433L4.21733 14.7507C4.8117 16.4377 5.93823 17.8859 7.42719 18.877C8.91615 19.8681 10.6869 20.3484 12.4726 20.2457C14.2583 20.1429 15.9622 19.4626 17.3276 18.3072C18.693 17.1518 19.646 15.584 20.0429 13.8399C20.4398 12.0958 20.2591 10.27 19.5281 8.63757C18.7971 7.00512 17.5553 5.65446 15.9899 4.7891C14.4246 3.92373 12.6203 3.59055 10.8491 3.83975C9.07791 4.08895 7.43567 4.90703 6.16983 6.17073C6.16379 6.17676 6.15765 6.18268 6.15141 6.1885L1.46286 10.56L0.439941 9.46291L5.11931 5.09996C6.61405 3.61173 8.5512 2.64828 10.6401 2.35438Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCcw);
export default __webpack_public_path__ + "static/media/rotate-ccw.1961b05333902bca72f8722ce59460c5.svg";
export { ForwardRef as ReactComponent };